import React from 'react';

export const ClearCompliance = () => {
  return (
    <section className="soccer-compliance-section">
      <>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 820 820"
          fill="none"
          className="soccer-compliance-top-svg"
        >
          <g opacity="0.5">
            <g filter="url(#filter0_f_3844_5866)">
              <circle
                cx="409.819"
                cy="409.808"
                r="295"
                transform="rotate(-30 409.819 409.808)"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M262.32 154.33C307.503 128.244 365.069 132.197 422.143 160.912C479.173 189.606 535.093 242.786 576.097 313.808C617.101 384.829 635.197 459.847 631.531 523.583C627.863 587.368 602.503 639.199 557.32 665.285C512.137 691.371 454.571 687.419 397.496 658.703C340.467 630.009 284.547 576.829 243.543 505.808C202.539 434.786 184.443 359.768 188.109 296.033C191.777 232.247 217.137 180.416 262.32 154.33Z"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M262.32 154.33C269.4 150.242 280.46 151.219 295.884 159.452C311.032 167.539 328.982 181.917 348.581 201.686C387.726 241.169 432.636 301.325 473.906 372.808C515.177 444.29 544.818 513.261 559.44 566.903C566.76 593.761 570.237 616.495 569.666 633.657C569.085 651.132 564.4 661.197 557.32 665.285C550.24 669.373 539.181 668.397 523.757 660.163C508.608 652.076 490.659 637.698 471.059 617.93C431.915 578.446 387.005 518.29 345.734 446.808C304.464 375.325 274.822 306.354 260.201 252.712C252.88 225.854 249.403 203.12 249.974 185.958C250.556 168.484 255.24 158.418 262.32 154.33Z"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M665.295 262.302C691.381 307.485 687.428 365.052 658.712 422.126C630.019 479.155 576.839 535.075 505.817 576.079C434.796 617.083 359.778 635.179 296.042 631.514C232.257 627.845 180.426 602.485 154.34 557.302C128.254 512.12 132.206 454.553 160.922 397.479C189.616 340.449 242.796 284.53 313.817 243.525C384.839 202.521 459.857 184.425 523.592 188.091C587.378 191.76 639.209 217.12 665.295 262.302Z"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M665.297 262.307C669.384 269.387 668.408 280.446 660.175 295.87C652.088 311.019 637.71 328.968 617.941 348.568C578.458 387.712 518.302 432.622 446.819 473.893C375.337 515.163 306.366 544.804 252.724 559.426C225.866 566.747 203.132 570.224 185.97 569.652C168.495 569.071 158.429 564.387 154.342 557.307C150.254 550.227 151.23 539.167 159.464 523.743C167.55 508.595 181.929 490.645 201.697 471.046C241.181 431.901 301.337 386.991 372.819 345.721C444.302 304.45 513.273 274.809 566.915 260.187C593.773 252.867 616.507 249.39 633.669 249.961C651.143 250.542 661.209 255.227 665.297 262.307Z"
                stroke="#EE2737"
                strokeWidth="10"
              />
            </g>
            <g filter="url(#filter1_f_3844_5866)">
              <circle
                cx="409.819"
                cy="409.808"
                r="295"
                transform="rotate(-30 409.819 409.808)"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M262.32 154.33C307.503 128.244 365.069 132.197 422.143 160.912C479.173 189.606 535.093 242.786 576.097 313.808C617.101 384.829 635.197 459.847 631.531 523.583C627.863 587.368 602.503 639.199 557.32 665.285C512.137 691.371 454.571 687.419 397.496 658.703C340.467 630.009 284.547 576.829 243.543 505.808C202.539 434.786 184.443 359.768 188.109 296.033C191.777 232.247 217.137 180.416 262.32 154.33Z"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M262.32 154.33C269.4 150.242 280.46 151.219 295.884 159.452C311.032 167.539 328.982 181.917 348.581 201.686C387.726 241.169 432.636 301.325 473.906 372.808C515.177 444.29 544.818 513.261 559.44 566.903C566.76 593.761 570.237 616.495 569.666 633.657C569.085 651.132 564.4 661.197 557.32 665.285C550.24 669.373 539.181 668.397 523.757 660.163C508.608 652.076 490.659 637.698 471.059 617.93C431.915 578.446 387.005 518.29 345.734 446.808C304.464 375.325 274.822 306.354 260.201 252.712C252.88 225.854 249.403 203.12 249.974 185.958C250.556 168.484 255.24 158.418 262.32 154.33Z"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M665.295 262.302C691.381 307.485 687.428 365.052 658.712 422.126C630.019 479.155 576.839 535.075 505.817 576.079C434.796 617.083 359.778 635.179 296.042 631.514C232.257 627.845 180.426 602.485 154.34 557.302C128.254 512.12 132.206 454.553 160.922 397.479C189.616 340.449 242.796 284.53 313.817 243.525C384.839 202.521 459.857 184.425 523.592 188.091C587.378 191.76 639.209 217.12 665.295 262.302Z"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M665.297 262.307C669.384 269.387 668.408 280.446 660.175 295.87C652.088 311.019 637.71 328.968 617.941 348.568C578.458 387.712 518.302 432.622 446.819 473.893C375.337 515.163 306.366 544.804 252.724 559.426C225.866 566.747 203.132 570.224 185.97 569.652C168.495 569.071 158.429 564.387 154.342 557.307C150.254 550.227 151.23 539.167 159.464 523.743C167.55 508.595 181.929 490.645 201.697 471.046C241.181 431.901 301.337 386.991 372.819 345.721C444.302 304.45 513.273 274.809 566.915 260.187C593.773 252.867 616.507 249.39 633.669 249.961C651.143 250.542 661.209 255.227 665.297 262.307Z"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
            </g>
            <g filter="url(#filter2_f_3844_5866)">
              <path
                d="M262.32 154.33C307.503 128.244 365.069 132.197 422.143 160.912C479.173 189.606 535.093 242.786 576.097 313.808C617.101 384.829 635.197 459.847 631.531 523.583C627.863 587.368 602.503 639.199 557.32 665.285C512.137 691.371 454.571 687.419 397.496 658.703C340.467 630.009 284.547 576.829 243.543 505.808C202.539 434.786 184.443 359.768 188.109 296.033C191.777 232.247 217.137 180.416 262.32 154.33Z"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M262.32 154.33C269.4 150.242 280.46 151.219 295.884 159.452C311.032 167.539 328.982 181.917 348.581 201.686C387.726 241.169 432.636 301.325 473.906 372.808C515.177 444.29 544.818 513.261 559.44 566.903C566.76 593.761 570.237 616.495 569.666 633.657C569.085 651.132 564.4 661.197 557.32 665.285C550.24 669.373 539.181 668.397 523.757 660.163C508.608 652.076 490.659 637.698 471.059 617.93C431.915 578.446 387.005 518.29 345.734 446.808C304.464 375.325 274.822 306.354 260.201 252.712C252.88 225.854 249.403 203.12 249.974 185.958C250.556 168.484 255.24 158.418 262.32 154.33Z"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <circle
                cx="409.819"
                cy="409.808"
                r="295"
                transform="rotate(60 409.819 409.808)"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M665.295 262.302C691.381 307.485 687.428 365.052 658.712 422.126C630.019 479.155 576.839 535.075 505.817 576.079C434.796 617.083 359.778 635.179 296.042 631.514C232.257 627.845 180.426 602.485 154.34 557.302C128.254 512.12 132.206 454.553 160.922 397.479C189.616 340.449 242.796 284.53 313.817 243.525C384.839 202.521 459.857 184.425 523.592 188.091C587.378 191.76 639.209 217.12 665.295 262.302Z"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M665.297 262.307C669.384 269.387 668.408 280.446 660.175 295.87C652.088 311.019 637.71 328.968 617.941 348.568C578.458 387.712 518.302 432.622 446.819 473.893C375.337 515.163 306.366 544.804 252.724 559.426C225.866 566.747 203.132 570.224 185.97 569.652C168.495 569.071 158.429 564.387 154.342 557.307C150.254 550.227 151.23 539.167 159.464 523.743C167.55 508.595 181.929 490.645 201.697 471.046C241.181 431.901 301.337 386.991 372.819 345.721C444.302 304.45 513.273 274.809 566.915 260.187C593.773 252.867 616.507 249.39 633.669 249.961C651.143 250.542 661.209 255.227 665.297 262.307Z"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f_3844_5866"
              x="89.7695"
              y="89.7578"
              width="640.1"
              height="640.102"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="10"
                result="effect1_foregroundBlur_3844_5866"
              />
            </filter>
            <filter
              id="filter1_f_3844_5866"
              x="89.7695"
              y="89.7578"
              width="640.1"
              height="640.102"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="10"
                result="effect1_foregroundBlur_3844_5866"
              />
            </filter>
            <filter
              id="filter2_f_3844_5866"
              x="108.37"
              y="108.358"
              width="602.9"
              height="602.902"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.7"
                result="effect1_foregroundBlur_3844_5866"
              />
            </filter>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 820 820"
          fill="none"
          className="soccer-compliance-bottom-svg"
        >
          <g opacity="0.5">
            <g filter="url(#filter0_f_3844_5796)">
              <circle
                cx="409.81"
                cy="409.831"
                r="300"
                transform="rotate(120 409.81 409.831)"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M150 259.828C128.185 297.613 226.82 395.401 370.308 478.244C513.795 561.087 647.8 597.613 669.615 559.828"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M428.638 510.207C450.49 500.692 502.257 467.495 534.511 410.83M534.511 410.83C532.339 397.259 518.791 353.257 481.98 285.816L518.48 222.596C540.603 217.278 575.544 208.758 645.456 260.667C655.361 278.511 683.891 318.096 680.39 380.159C673.352 391.683 653.642 420.488 631.114 443.508C618.333 439.979 581.119 428.503 534.511 410.83Z"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M631.121 443.5C635.418 462.724 638.167 515.695 614.788 573.789"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M680.398 380.148C687.071 385.925 702.088 406.181 708.78 440.99"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M645.453 260.671C648.852 258.784 656.06 251.899 657.703 239.453"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M313.895 443.957C311.209 420.275 314.075 358.845 347.022 302.58M347.022 302.58C359.861 297.675 404.741 287.407 481.552 285.566L518.052 222.346C511.596 200.528 501.504 166.008 421.594 131.417C401.188 131.761 352.642 126.846 300.644 160.909C294.182 172.767 279.092 204.238 270.42 235.258C279.867 244.562 308.413 271.053 347.022 302.58Z"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M270.424 235.25C251.627 241.141 204.378 265.245 165.757 314.539"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M300.648 160.898C292.31 158.008 267.259 155.131 233.767 166.74"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M421.594 131.421C421.528 127.534 423.887 117.849 433.844 110.203"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M429.338 510.013C435.995 528.483 443.699 574.538 421.26 611.004C439.829 623.842 481.403 653.233 499.148 668.097C516.673 664.744 564.274 641.496 614.481 575.336"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M499.146 668.102C500.2 672.944 499.774 686.015 489.642 699.564"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M421.259 611.008C396.888 615.22 338.016 619.989 297.496 605.371L286.996 623.558C296.625 638.547 331.748 676.646 395.209 709.128"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M314.152 443.513C294.829 446.983 251.091 463.338 230.73 501.004C210.328 491.342 164.087 470.033 142.342 462.097C136.484 445.244 132.816 392.396 165.009 315.836"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M142.342 462.102C137.622 463.61 126.515 470.515 119.847 486.064"
                stroke="#EE2737"
                strokeWidth="10"
              />
              <path
                d="M230.733 501.008C239.271 524.22 264.577 577.589 297.496 605.371L286.996 623.558C269.201 622.714 218.645 611.346 158.784 572.628"
                stroke="#EE2737"
                strokeWidth="10"
              />
            </g>
            <g filter="url(#filter1_f_3844_5796)">
              <circle
                cx="409.81"
                cy="409.831"
                r="300"
                transform="rotate(120 409.81 409.831)"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M150 259.828C128.185 297.613 226.82 395.401 370.308 478.244C513.795 561.087 647.8 597.613 669.615 559.828"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M428.638 510.207C450.49 500.692 502.257 467.495 534.511 410.83M534.511 410.83C532.339 397.259 518.791 353.257 481.98 285.816L518.48 222.596C540.603 217.278 575.544 208.758 645.456 260.667C655.361 278.511 683.891 318.096 680.39 380.159C673.352 391.683 653.642 420.488 631.114 443.508C618.333 439.979 581.119 428.503 534.511 410.83Z"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M631.121 443.5C635.418 462.724 638.167 515.695 614.788 573.789"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M680.398 380.148C687.071 385.925 702.088 406.181 708.78 440.99"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M645.453 260.671C648.852 258.784 656.06 251.899 657.703 239.453"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M313.895 443.957C311.209 420.275 314.075 358.845 347.022 302.58M347.022 302.58C359.861 297.675 404.741 287.407 481.552 285.566L518.052 222.346C511.596 200.528 501.504 166.008 421.594 131.417C401.188 131.761 352.642 126.846 300.644 160.909C294.182 172.767 279.092 204.238 270.42 235.258C279.867 244.562 308.413 271.053 347.022 302.58Z"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M270.424 235.25C251.627 241.141 204.378 265.245 165.757 314.539"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M300.648 160.898C292.31 158.008 267.259 155.131 233.767 166.74"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M421.594 131.421C421.528 127.534 423.887 117.849 433.844 110.203"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M429.338 510.013C435.995 528.483 443.699 574.538 421.26 611.004C439.829 623.842 481.403 653.233 499.148 668.097C516.673 664.744 564.274 641.496 614.481 575.336"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M499.146 668.102C500.2 672.944 499.774 686.015 489.642 699.564"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M421.259 611.008C396.888 615.22 338.016 619.989 297.496 605.371L286.996 623.558C296.625 638.547 331.748 676.646 395.209 709.128"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M314.152 443.513C294.829 446.983 251.091 463.338 230.73 501.004C210.328 491.342 164.087 470.033 142.342 462.097C136.484 445.244 132.816 392.396 165.009 315.836"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M142.342 462.102C137.622 463.61 126.515 470.515 119.847 486.064"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
              <path
                d="M230.733 501.008C239.271 524.22 264.577 577.589 297.496 605.371L286.996 623.558C269.201 622.714 218.645 611.346 158.784 572.628"
                stroke="#EE2737"
                strokeOpacity="0.2"
                strokeWidth="10"
              />
            </g>
            <g filter="url(#filter2_f_3844_5796)">
              <circle
                cx="409.81"
                cy="409.831"
                r="300"
                transform="rotate(120 409.81 409.831)"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M150 259.828C128.185 297.613 226.82 395.401 370.308 478.244C513.795 561.087 647.8 597.613 669.615 559.828"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M428.638 510.207C450.49 500.692 502.257 467.495 534.511 410.83M534.511 410.83C532.339 397.259 518.791 353.257 481.98 285.816L518.48 222.596C540.603 217.278 575.544 208.758 645.456 260.667C655.361 278.511 683.891 318.096 680.39 380.159C673.352 391.683 653.642 420.488 631.114 443.508C618.333 439.979 581.119 428.503 534.511 410.83Z"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M631.121 443.5C635.418 462.724 638.167 515.695 614.788 573.789"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M680.398 380.148C687.071 385.925 702.088 406.181 708.78 440.99"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M645.453 260.671C648.852 258.784 656.06 251.899 657.703 239.453"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M313.895 443.957C311.209 420.275 314.075 358.845 347.022 302.58M347.022 302.58C359.861 297.675 404.741 287.407 481.552 285.566L518.052 222.346C511.596 200.528 501.504 166.008 421.594 131.417C401.188 131.761 352.642 126.846 300.644 160.909C294.182 172.767 279.092 204.238 270.42 235.258C279.867 244.562 308.413 271.053 347.022 302.58Z"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M270.424 235.25C251.627 241.141 204.378 265.245 165.757 314.539"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M300.648 160.898C292.31 158.008 267.259 155.131 233.767 166.74"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M421.594 131.421C421.528 127.534 423.887 117.849 433.844 110.203"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M429.338 510.013C435.995 528.483 443.699 574.538 421.26 611.004C439.829 623.842 481.403 653.233 499.148 668.097C516.673 664.744 564.274 641.496 614.481 575.336"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M499.146 668.102C500.2 672.944 499.774 686.015 489.642 699.564"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M421.259 611.008C396.888 615.22 338.016 619.989 297.496 605.371L286.996 623.558C296.625 638.547 331.748 676.646 395.209 709.128"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M314.152 443.513C294.829 446.983 251.091 463.338 230.73 501.004C210.328 491.342 164.087 470.033 142.342 462.097C136.484 445.244 132.816 392.396 165.009 315.836"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M142.342 462.102C137.622 463.61 126.515 470.515 119.847 486.064"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
              <path
                d="M230.733 501.008C239.271 524.22 264.577 577.589 297.496 605.371L286.996 623.558C269.201 622.714 218.645 611.346 158.784 572.628"
                stroke="#EE2737"
                strokeOpacity="0.6"
                strokeWidth="10"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f_3844_5796"
              x="84.7578"
              y="84.7812"
              width="650.104"
              height="650.102"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="10"
                result="effect1_foregroundBlur_3844_5796"
              />
            </filter>
            <filter
              id="filter1_f_3844_5796"
              x="84.7578"
              y="84.7812"
              width="650.104"
              height="650.102"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="10"
                result="effect1_foregroundBlur_3844_5796"
              />
            </filter>
            <filter
              id="filter2_f_3844_5796"
              x="103.358"
              y="103.381"
              width="612.904"
              height="612.902"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feGaussianBlur
                stdDeviation="0.7"
                result="effect1_foregroundBlur_3844_5796"
              />
            </filter>
          </defs>
        </svg>
      </>

      <h2 className="soccer-compliance-title">CLEAR COMPLIANCE</h2>
      <p className="soccer-compliance-description">
        Orqa manufactures all equipment in the EU and sources critical
        components from trusted, vetted suppliers, ensuring full NDAA compliance
        and alignment with the highest safety, privacy, and operational
        standards.
      </p>
    </section>
  );
};
